module.exports = __webpack_public_path__ + "static/media/arrowTop.bf3675c3.svg";